export default __webpack_public_path__ + "static/media/brand.04369f2b.gif";